export enum CalculationType {
	UnitPrice = 0,
	HourlyRate = 1,
}
